import { FacetId } from '@grandvisionhq/search';
import { getComponentByPath } from './get-component-by-path.js';
import { getContentByRef } from './get-content-by-ref.js';

/**
 * This function is only used in opco sites to configure Algolia on the server.
 */ function getAlgoliaConfigFromBloomreach(pageModel) {
    var ref, ref1, ref2;
    if (!pageModel) {
        return {
            isEnabled: false
        };
    }
    const container = getComponentByPath('main/container', pageModel);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const component = container === null || container === void 0 ? void 0 : (ref = container.components) === null || ref === void 0 ? void 0 : ref.find((c)=>c.label === 'Product catalog v2'
    );
    const content = getContentByRef(component === null || component === void 0 ? void 0 : (ref1 = component.models) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.document) === null || ref2 === void 0 ? void 0 : ref2.$ref, pageModel);
    const isEnabled = !!component;
    const presetQueryString = getPresetQueryString(content);
    var ref3;
    const ruleContexts = (ref3 = content === null || content === void 0 ? void 0 : content.ruleContexts) !== null && ref3 !== void 0 ? ref3 : [];
    const isPrescriptionGlasses = presetQueryString.toLowerCase().includes('frames') || presetQueryString.toLowerCase().includes('sunglasses');
    const facetingAfterDistinct = !isPrescriptionGlasses;
    return {
        isEnabled,
        presetQueryString,
        ruleContexts,
        facetingAfterDistinct
    };
}
function getPresetQueryString(content) {
    if (!content) {
        return '';
    }
    let presetQueryString = (content.filterQuery || '').split('#')[0];
    const categoryExternalId = content.categoryExternalId || '';
    if (categoryExternalId) {
        const symbol = presetQueryString.includes('?') ? '&' : '?';
        presetQueryString += symbol + `${FacetId.categoryExternalId}=${categoryExternalId}`;
    }
    return presetQueryString;
}

export { getAlgoliaConfigFromBloomreach };
//# sourceMappingURL=get-algolia-config-from-bloomreach.js.map
